// src/components/AnalyticsConsentBanner.jsx
import { useEffect, useState } from "react";
import {
  getStoredAnalyticsConsent,
  updateAnalyticsConsent,
} from "../utils/analyticsConsent";

export default function AnalyticsConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show banner only until user makes an explicit choice.
    const stored = getStoredAnalyticsConsent();
    setVisible(stored === null);
  }, []);

  if (!visible) return null;

  const onContinue = () => {
    // Explicitly record the "granted" choice (even though default is granted),
    // so we stop showing the banner next time.
    updateAnalyticsConsent("granted");
    setVisible(false);
  };

  const onOptOut = () => {
    updateAnalyticsConsent("denied");
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-teal-100 bg-white/95 backdrop-blur"
      role="region"
      aria-label="Analytics notice"
    >
      <div className="mx-auto max-w-6xl px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="text-sm text-gray-700">
            <span className="font-semibold text-teal-900">Analytics notice:</span>{" "}
            We use analytics cookies to understand how our site is used and to improve our services.
            You can opt out at any time.
            <span className="ml-2">
              <a href="/privacy" className="font-semibold text-teal-800 hover:underline">
                Privacy policy
              </a>
            </span>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end sm:gap-3">
            <button
              type="button"
              onClick={onOptOut}
              className="rounded-full border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
            >
              Opt out
            </button>

            <button
              type="button"
              onClick={onContinue}
              className="rounded-full bg-xlzyellow px-5 py-2 text-sm font-bold text-xlzteal hover:bg-yellow-300"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
